import { jsx as _jsx } from "preact/jsx-runtime";
import { createContext } from 'preact';
import { useContext, useMemo, useState } from 'preact/hooks';
const PageHeaderContext = createContext(undefined);
export function PageHeaderProvider({ children }) {
    const [header, setHeaderState] = useState({ items: [] });
    const value = useMemo(() => ({
        header,
        setHeader: (state) => setHeaderState(state),
        clearHeader: () => setHeaderState({ items: [] })
    }), [header]);
    return (_jsx(PageHeaderContext.Provider, { value: value, children: children }));
}
export function usePageHeader() {
    const ctx = useContext(PageHeaderContext);
    if (!ctx)
        throw new Error('usePageHeader must be used within a PageHeaderProvider');
    return ctx;
}
